import { render, staticRenderFns } from "./ListadoConceptoUniversidad.vue?vue&type=template&id=01ca9788"
import script from "./ListadoConceptoUniversidad.vue?vue&type=script&lang=js"
export * from "./ListadoConceptoUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ListadoConceptoUniversidad.vue?vue&type=style&index=0&id=01ca9788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports